import { render } from "./StatisticsPortalViewsCountByNavigationTab.vue?vue&type=template&id=3d1958cb&ts=true"
import script from "./StatisticsPortalViewsCountByNavigationTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalViewsCountByNavigationTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__